const InlineEditor = require('@ckeditor/ckeditor5-build-inline/build/ckeditor')

let gEditor;

document.addEventListener("turbolinks:load", () => {
  if ( document.querySelector( '#subscription_type_description_div' ) != null ){
    InlineEditor
      .create( document.querySelector( '#subscription_type_description_div' ), {
          toolbar: [ 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo' ],
          placeholder: 'Info'
      }  )
      .then( editor => {
          console.log( editor );
          console.log(Array.from( editor.ui.componentFactory.names()));
          gEditor = editor;
          // editors.push(editor);
      })
      .catch( error => {
          console.log( error );
      });
    if (document.querySelector( '#st_form' ) != null){
      document.querySelector( '#st_form' ).addEventListener( 'submit', () => {
        $('#subscription_type_description').val(gEditor.getData())
      } );
    }
  }
});
